import React from 'react';

import { Dot, Wrapper } from './SidebarMenuDot.styles';

export function SidebarMenuDot(props: { isNew?: boolean }) {
    return (
        <Wrapper>
            <Dot $new={props.isNew} />
        </Wrapper>
    );
}
